var render, staticRenderFns
import script from "./supplierList.vue?vue&type=script&lang=js&"
export * from "./supplierList.vue?vue&type=script&lang=js&"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=2cb7520b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7520b",
  null
  
)

export default component.exports